import React, { useEffect } from 'react';
import styled from 'styled-components';
import { HOTJAR_TRACKING_LABEL } from '../../../../core/tracking/hotjar/constants';
import { analyticsTagHotjarRecording } from '../../../../core/analytics';
import useCategories from './hooks/useCategories';
import useHandleObserverChange from './hooks/useHandleObserverChange';
import useHandleDismissTile from './hooks/useHandleDismissTile';
import CategoryComponent from './components/CategoryComponent';
import useSelectInsuranceProfile from '../../hooks/useSelectInsuranceProfile';

type Props = {
  userProfile: any;
  className?: string;
  categoryIds?: string[];
};

const Root = styled.div.withConfig({ componentId: 'sc-hv06uk-0' })`
  padding: 0 16px;
`;

const SwimLanes = (props: Props) => {
  const { userProfile, categoryIds, className } = props;

  useEffect(() => {
    const hotjarTags = [HOTJAR_TRACKING_LABEL.account];
    analyticsTagHotjarRecording(hotjarTags);
  }, []);

  const handleObserverChange = useHandleObserverChange(userProfile);
  const handleDismissTile = useHandleDismissTile();
  const insuranceProfile = useSelectInsuranceProfile(userProfile.user_profile_id);

  return (
    <Root className={className}>
      {useCategories(categoryIds).map((category: any) => (
        <CategoryComponent
          category={category}
          handleDismissTile={handleDismissTile}
          handleObserverChange={handleObserverChange}
          insuranceProfile={insuranceProfile}
          key={category.id}
          userProfile={userProfile}
        />
      ))}
    </Root>
  );
};

export default SwimLanes;
